module.exports = __webpack_public_path__ + "vector.png";